import type { ReadingType } from 'infrastructure/enums';

export type StepId =
  | 'reading-status'
  | 'contact'
  | 'consent'
  | 'recheck'
  | 'symptoms'
  | 'outcome';

export type Outcome =
  | 'warm-transfer'
  | 'escalate-clinic'
  | '911'
  | 'reading-recovered-closed'
  | 'do-not-escalate'
  | 'follow-runbook';

/** Display label for each outcome — shared by the #6 menu and the chart note. */
export const OUTCOME_LABELS: Record<Outcome, string> = {
  'warm-transfer': 'Warm Transfer/Callback to TH Nurse',
  'escalate-clinic': 'Escalated to Clinic',
  '911': '911 / Emergency Services',
  'reading-recovered-closed': 'Reading Recovered — Closed',
  'do-not-escalate': 'Do Not Escalate',
  'follow-runbook': 'Follow Runbook Action',
};

export type RecheckResult =
  | 'normal'
  | 'at-risk'
  | 'still-critical'
  | 'unable-to-recheck';

export type ParamLevel = 'normal' | 'risk' | 'critical';
export type ParamDirection = 'high' | 'low';

export interface OutOfRangeParam {
  param: string;
  level: ParamLevel;
  direction: ParamDirection;
}

export interface ReadingContext {
  readingType: ReadingType;
  outOfRangeParams: OutOfRangeParam[];
}

export interface Answers {
  readingStatus?: 'still-critical' | 'already-recovered';
  contact?: 'reached' | 'not-reached';
  unableToReachRunbook?: 'do-not-escalate' | 'no-entry';
  consent?: 'patient' | 'representative' | 'unable-to-verify';
  representativeName?: string;
  representativeRelationship?: string;
  representativeAttestation?: boolean;
  recheck?: RecheckResult;
  symptoms?: Record<string, boolean>;
  symptomsOther?: string;
  atRiskRunbook?: 'has-entry' | 'no-entry';
  runbookAction?: 'warm-transfer' | 'escalate-clinic' | '911' | 'other';
  runbookActionOther?: string;
  outcome?: Outcome;
  overrideReason?: string;
  escalationMethod?: 'phone' | 'sms' | 'email' | 'ehr-case' | 'ccm-team';
  warmTransferConfirmed?: boolean;
}

export interface EngineState {
  currentStep: StepId;
  visibleSteps: StepId[];
  preSelectedOutcome: Outcome | null;
  noLiveCall: boolean;
}
